/** Add-to-home-screen onboarding helpers (session + permanent flags). */

export const A2HS_PENDING_KEY = "a2hs_pending_after_signup";
export const A2HS_DONE_KEY = "a2hs_done";
export const A2HS_MAYBE_LATER_KEY = "a2hs_maybe_later_session";
export const A2HS_RESURFACED_KEY = "a2hs_resurfaced_once";

export function isStandaloneDisplay() {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  // iOS Safari legacy
  if (window.navigator.standalone === true) return true;
  return false;
}

export function isIosLike() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const iOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|Chrome|Chromium|Android/.test(ua);
  // Treat iPadOS/iPhone browsers that lack beforeinstallprompt as instructional.
  return iOS || (isSafari && !/Android/i.test(ua) && "ontouchend" in document);
}

export function markA2hsPendingAfterSignup() {
  try {
    sessionStorage.setItem(A2HS_PENDING_KEY, "1");
  } catch (_) {}
}

export function consumeA2hsPendingAfterSignup() {
  try {
    const v = sessionStorage.getItem(A2HS_PENDING_KEY);
    if (v) sessionStorage.removeItem(A2HS_PENDING_KEY);
    return v === "1";
  } catch (_) {
    return false;
  }
}

export function peekA2hsPendingAfterSignup() {
  try {
    return sessionStorage.getItem(A2HS_PENDING_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function isA2hsDone() {
  try {
    return localStorage.getItem(A2HS_DONE_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function markA2hsDone() {
  try {
    localStorage.setItem(A2HS_DONE_KEY, "1");
    sessionStorage.removeItem(A2HS_PENDING_KEY);
    sessionStorage.removeItem(A2HS_MAYBE_LATER_KEY);
  } catch (_) {}
}

export function markA2hsMaybeLater() {
  try {
    sessionStorage.setItem(A2HS_MAYBE_LATER_KEY, "1");
    sessionStorage.removeItem(A2HS_PENDING_KEY);
  } catch (_) {}
}

export function isA2hsMaybeLaterThisSession() {
  try {
    return sessionStorage.getItem(A2HS_MAYBE_LATER_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function hasA2hsResurfaced() {
  try {
    return localStorage.getItem(A2HS_RESURFACED_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function markA2hsResurfaced() {
  try {
    localStorage.setItem(A2HS_RESURFACED_KEY, "1");
  } catch (_) {}
}

/** Should we show the full post-signup A2HS step? */
export function shouldShowA2hsOnboarding() {
  if (isStandaloneDisplay()) return false;
  if (isA2hsDone()) return false;
  if (isA2hsMaybeLaterThisSession()) return false;
  return peekA2hsPendingAfterSignup();
}

/**
 * Lighter resurface: once, after maybe-later, when a push-related moment
 * arrives while still not installed.
 */
export function shouldResurfaceA2hsLight() {
  if (isStandaloneDisplay()) return false;
  if (isA2hsDone()) return false;
  if (hasA2hsResurfaced()) return false;
  if (!isA2hsMaybeLaterThisSession()) return false;
  return true;
}
